import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "User",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/user/Login.vue"),
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: () =>
      import(/* webpackChunkName: "forgot" */ "@/views/user/Forgot.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "register" */ "@/views/user/Register.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/home/index.vue"),
  },
  {
    path: "/singUp",
    name: "singUp",
    component: () =>
      import(/* webpackChunkName: "singUp" */ "@/views/singUp/singUp.vue"),
  },
  {
    path: "/singUpLook",
    name: "singUpLook",
    component: () =>
      import(
        /* webpackChunkName: "singUpLook" */ "@/views/singUp/singUpLook.vue"
      ),
  },
  {
    path: "/fractionLook",
    name: "fractionLook",
    component: () =>
      import(
        /* webpackChunkName: "singUpLook" */ "@/views/singUp/fractionLook.vue"
      ),
  },
  {
    path: "/arrivalIntent",
    name: "arrivalIntent",
    component: () =>
      import(
        /* webpackChunkName: "arrivalIntent" */ "@/views/singUp/arrivalIntent.vue"
      ),
  },

  {
    path: "/notice",
    name: "Notice",
    component: () =>
      import(/* webpackChunkName: "notice" */ "@/views/notice/index.vue"),
  },
  {
    path: "/noticeDetail",
    name: "NoticeDetail",
    component: () =>
      import(/* webpackChunkName: "notice" */ "@/views/notice/detail.vue"),
  },
  {
    path: "/qa",
    name: "QA",
    component: () =>
      import(/* webpackChunkName: "qa" */ "@/views/qa/index.vue"),
  },
  {
    path: "/qaDetail",
    name: "QADetail",
    component: () =>
      import(/* webpackChunkName: "qa" */ "@/views/qa/detail.vue"),
  },
  {
    path: "/mine",
    name: "Mine",
    component: () =>
      import(/* webpackChunkName: "mine" */ "@/views/mine/mine.vue"),
  },
  {
    path: "/AiView",
    name: "AiView",
    component: () =>
      import(/* webpackChunkName: "mine" */ "@/views/AI/Aiview.vue"),
  },
];

const router = new VueRouter({
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  base: process.env.BASE_URL,
  routes,
});
export default router;
